import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import withRouter from './withRouter';

// Move selector outside component to maintain memoization
const selectLayoutState = (state: any) => state.Layout;
const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout) => ({
        preloader: layout.preloader,
    })
);

const RightSidebar = (props: any) => {
    const { preloader } = useSelector(selectLayoutProperties);

    const toTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    useEffect(() => {
        const handleScroll = () => {
            const element = document.getElementById('back-to-top');
            if (!element) {
                return;
            }
            if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
                element.style.display = 'block';
            } else {
                element.style.display = 'none';
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const pathName = props.router.location.pathname;

    useEffect(() => {
        const preloaderElement = document.getElementById('preloader') as HTMLElement | null;
        if (!preloaderElement || preloader !== 'enable') {
            return;
        }

        preloaderElement.style.opacity = '1';
        preloaderElement.style.visibility = 'visible';

        const timeoutId = window.setTimeout(() => {
            preloaderElement.style.opacity = '0';
            preloaderElement.style.visibility = 'hidden';
        }, 1000);

        return () => window.clearTimeout(timeoutId);
    }, [pathName, preloader]);

    return (
        <React.Fragment>
            <button onClick={toTop} className="btn btn-danger btn-icon" id="back-to-top">
                <i className="ri-arrow-up-line"></i>
            </button>

            {preloader === 'enable' && (
                <div id="preloader">
                    <div id="status">
                        <div className="spinner-border text-primary avatar-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default withRouter(RightSidebar);
